import { getPhotosForPhotowall } from 'entities/photos';

Pixlee.module('VerticalApp.Show', function(Show, App, Backbone, Marionette, $) {
    Show.Controller = App.Controllers.Application.extend({
        initialize: function(options) {
            var collectionView, headerView;
            var _this = this;
            this.layout = new Show.Layout();
            this.listenTo(this.layout, 'show', function() {
                var photoscollection = getPhotosForPhotowall();
                collectionView = new Show.VerticalCollection({
                    collection: photoscollection,
                    displayOptions: options.display_options
                });
                this.layout.collection = photoscollection;
                photoscollection.on('sync', function(collection, resp) {
                    if (_this.widgetloaded) {
                        return false;
                    }
                    _this.widgetloaded = true;
                    gon.sortType = resp.sortType;

                    var hasTile = options.display_options.headerOptions.end_tile_upload_button_background_showHide;
                    if (collectionView.sly || hasTile) {
                        var rel = collectionView.sly ? collectionView.sly.rel : {};
                        App.commands.execute('opened:vertical', rel, photoscollection);
                    }
                });
                this.headerView = new Show.HeaderView({
                    model: App.currentAlbum
                });
                this.layout.frame.show(collectionView);
                this.layout.widget_header_region.show(this.headerView);
            });
            if (!_.isFalsy(gon.previewMode)) {
                var header_sponserImage_input;

                App.commands.setHandler('stylesheet:generated', function(css, params) {
                    header_sponserImage_input = header_sponserImage_input || params.header_sponserImage_input;
                    if (!_.isFalsy(params.header_sponserImage_input)) {
                        header_sponserImage_input = params.header_sponserImage_input;
                        App.displayOptions.set('header_sponserImage_input', header_sponserImage_input);
                        headerView = new Show.HeaderView({
                            model: App.currentAlbum
                        });
                        _this.show(headerView, {
                            region: this.layout.widget_header_region
                        });
                    }

                    if (params.widget_photoSize != "250") {
                        collectionView.triggerMethod('reload:sly');
                    }


                    collectionView.triggerMethod('stylesheet:generated');
                });
            }
            this.show(this.layout, {
                loading: true
            });
        },
    });



});
